/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { t } from '../../locales/i18n';
import { Button, Modal, Icon } from 'semantic-ui-react';

interface ConfirmDialogButtonState {
  modalIsOpen: boolean;
}
interface ConfirmDialogButtonProps {
  buttonLabel?: string;
  buttonLabelStyle?: any;
  modalTitle?: string;
  modalSubtitle?: string;
  onModalConfirm: any;
  buttonDisabled?: boolean;
  title?: string;
  confirmDisabled?: boolean;
  children?: any;
}
export default class ConfirmDialogButton extends React.Component<
  ConfirmDialogButtonProps,
  ConfirmDialogButtonState
> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(props: any) {
    super(props);
    this.state = {
      modalIsOpen: false
    };
  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  handleClose() {
    this.setState({ modalIsOpen: false });
  }

  confirmModal() {
    if (this.props.onModalConfirm()) {
      this.handleClose();
    }
  }

  override render() {
    const { props } = this;
    const { buttonDisabled, modalSubtitle } = props;
    return (
      <span>
        <Modal
          trigger={
            <Icon
              name="sign in alternate"
              size="large"
              disabled={buttonDisabled}
              onClick={() => this.openModal()}
            />
          }
          open={this.state.modalIsOpen}
          onClose={() => this.handleClose()}
        >
          <Modal.Header>{this.props.title}</Modal.Header>
          <Modal.Header>{modalSubtitle}</Modal.Header>
          <Modal.Content>{props.children}</Modal.Content>
          <Modal.Actions>
            <Button
              disabled={this.props.confirmDisabled}
              primary
              onClick={() => this.confirmModal()}
              content={t('OK')}
            />
            <Button onClick={() => this.handleClose()} content={t('Cancel')} />
          </Modal.Actions>
        </Modal>
      </span>
    );
  }
}
